import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import sampleTag from './sample-tag';
import { Order } from '../../types/order';
import { format } from 'date-fns';

interface ModalOrderTagProps {
    isOpen: boolean;
    toggle: () => void;
    order: Order;
}

const ModalOrderTag: React.FC<ModalOrderTagProps> = ({ isOpen, toggle, order }) => {
    const [codeString, setCodeString] = useState<string>('');

    useEffect(() => {
        updateCodeString(order);
    }, [order]);

    const updateCodeString = (order: Order) => {
        const campaign = order.campaign;
        const replacements = {
            '[ID_PEDIDO]': String(order.id),
            '[ID_CAMPANHA]': String(campaign?.id),
            '[NOME_CAMPANHA]': campaign?.name,
            '[NOME_AGENCIA]': campaign?.agency?.name,
            '[NOME_VEICULO]': order.site?.publisher?.name,
            '[NOME_CLIENTE]': campaign?.advertiser?.name,
            '[SEGMENTACAO]': order.segmentation,
            '[LINHA_CRIATIVA]': order.creativeLine,
            '[REGIAO]': 'NACIONAL',
            '[NOME_FORMATO]': order.placement?.name,
            '[TAMANHO_FORMATO]': order.sizes.join(', '),
            '[DATA_INICIO]': format(new Date(order.startDate), 'dd/MM/yyyy'),
            '[DATA_TERMINO]': format(new Date(order.endDate), 'dd/MM/yyyy'),
        };
        const text = Object.entries(replacements).reduce(
            (acc, [key, value]) => acc.replaceAll(key, value || ''),
            sampleTag,
        );
        setCodeString(text);
    }

    const downloadTag = () => {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(codeString));
        element.setAttribute('download', `${order.id} - AD PULSE TAG.txt`);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} className="bg-light p-3">
                TAG
            </ModalHeader>
            <ModalBody>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <p>
                                Insira a TAG abaixo no creative do seu Ad Manager.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <SyntaxHighlighter language="xml" style={docco}>
                                {codeString}
                            </SyntaxHighlighter>
                            <div className="position-absolute top-0 end-0 pt-2" style={{ paddingRight: '1.3rem' }}>
                                <button className="btn btn-outline-primary btn-sm me-2" type="button"
                                        onClick={() => navigator.clipboard.writeText(codeString)}>
                                    <i className="ri-file-copy-line"></i>
                                </button>
                                <button className="btn btn-outline-info btn-sm" type="button" onClick={downloadTag}>
                                    <i className="ri-download-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ModalOrderTag;